import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "detail-page"
};
const _hoisted_2 = {
  class: "left shadow-box"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "floor-wrap"
};
const _hoisted_5 = {
  class: "col-item"
};
const _hoisted_6 = {
  class: "col-item"
};
const _hoisted_7 = {
  class: "col-item"
};
const _hoisted_8 = {
  class: "col-item"
};
const _hoisted_9 = {
  class: "col-item"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "biz-div"
};
const _hoisted_12 = {
  class: "biz-div"
};
const _hoisted_13 = {
  class: "blue"
};
const _hoisted_14 = {
  class: "blue"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "footer-bar"
};
const _hoisted_17 = {
  class: "line-text gutter-bottom"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 2
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 3,
  class: "other-image"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  key: 4,
  class: "line-text"
};
const _hoisted_26 = {
  class: "line-text"
};
const _hoisted_27 = {
  key: 5,
  class: "line-text gutter-bottom"
};
const _hoisted_28 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_assets_biz = _resolveComponent("assets-biz");
  const _component_assets_pos = _resolveComponent("assets-pos");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_tag_modal = _resolveComponent("tag-modal");
  const _component_add_assets_product = _resolveComponent("add-assets-product");
  const _component_select_favorite = _resolveComponent("select-favorite");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[9] || (_cache[9] = _createTextVNode("基本信息 ", -1)), _createVNode(_component_el_button, {
    type: "primary",
    size: "mini",
    style: {
      "margin-left": "12px"
    },
    onClick: $setup.editHandler
  }, {
    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("修改", -1)]))]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, "需求名称： " + _toDisplayString($setup.detail.needName), 1), _createElementVNode("div", _hoisted_6, "需求创建人： " + _toDisplayString($setup.detail.needUser), 1), _createElementVNode("div", _hoisted_7, "设计方： " + _toDisplayString($setup.detail.needDesigner), 1), _createElementVNode("div", _hoisted_8, "入库时间： " + _toDisplayString($setup.detail.createTime), 1), _createElementVNode("div", _hoisted_9, "素材有效期： " + _toDisplayString($setup.detail.bgnDate + " 至 " + $setup.detail.endDate), 1)]), _createElementVNode("div", _hoisted_10, [_cache[13] || (_cache[13] = _createTextVNode("关联业务 ", -1)), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    size: "mini",
    style: {
      "margin-left": "12px"
    },
    onClick: $setup.addAsProduct
  }, {
    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("添加", -1)]))]),
    _: 1
  }, 8, ["onClick"])), [[_directive_has, 'asset:lib:detail:product']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    size: "mini",
    style: {
      "margin-left": "12px"
    },
    onClick: $setup.downloadAssetProductModel
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("下载模板", -1)]))]),
    _: 1
  }, 8, ["onClick"])), [[_directive_has, 'asset:lib:detail:product']]), _createVNode(_component_el_upload, {
    style: {
      "margin-left": "12px"
    },
    ref: "upload",
    action: "",
    "http-request": $setup.fileUpload,
    "show-file-list": false,
    "auto-upload": true
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
      size: "mini",
      type: "primary"
    }, {
      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("批量导入", -1)]))]),
      _: 1
    })), [[_directive_has, 'asset:lib:detail:product']])]),
    _: 1
  }, 8, ["http-request"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_assets_biz, {
    id: $props.id,
    ref: "assetsBizRef"
  }, null, 8, ["id"])]), _cache[20] || (_cache[20] = _createElementVNode("div", {
    class: "title"
  }, "素材投放情况", -1)), _createElementVNode("div", _hoisted_12, [_createVNode(_component_assets_pos, {
    id: $props.id,
    onHasOffline: $setup.showPut
  }, null, 8, ["id", "onHasOffline"])]), _createElementVNode("div", null, [_createVNode(_component_el_tabs, {
    modelValue: _ctx.queryAssetBizParam.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.queryAssetBizParam.tab = $event),
    onTabClick: $setup.handleClick
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      name: "1"
    }, {
      label: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createElementVNode("span", null, "投放中", -1)]))]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "历史投放",
      name: "3"
    }, {
      label: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("span", null, "历史投放", -1)]))]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "待投放",
      name: "2"
    }, {
      label: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createElementVNode("span", null, "待投放", -1)]))]),
      _: 1
    }), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetsBizData, biz => {
      return _openBlock(), _createElementBlock("div", {
        class: "biz-item",
        key: biz.id
      }, [_cache[17] || (_cache[17] = _createElementVNode("div", null, "投放点位：", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(biz.positionName), 1), _cache[18] || (_cache[18] = _createElementVNode("div", {
        style: {
          "margin-left": "20px"
        }
      }, "投放时间：", -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(biz.bgnDate) + " 至 " + _toDisplayString(biz.endDate), 1)]);
    }), 128)), _ctx.assetsBizData.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[19] || (_cache[19] = [_createElementVNode("div", null, "暂无该项数据", -1)]))])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["modelValue", "onTabClick"])])]), _createVNode(_component_el_aside, {
    class: "shadow-box"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_ctx.showPutBtn ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      size: "small",
      type: "primary",
      icon: "el-icon-document",
      onClick: $setup.assetPut
    }, {
      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("投放", -1)]))]),
      _: 1
    }, 8, ["onClick"])), [[_directive_has, 'asset:lib:detail:put']]) : _createCommentVNode("", true), !$setup.detail.favorite ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      size: "small",
      type: "default",
      icon: "el-icon-star-off",
      onClick: $setup.favHandler
    }, {
      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("收藏", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true), $setup.detail.favorite ? (_openBlock(), _createBlock(_component_el_button, {
      key: 2,
      size: "small",
      type: "default",
      icon: "el-icon-star-on",
      onClick: $setup.favHandler
    }, {
      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("已收藏", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      loading: _ctx.isDownloading,
      size: "small",
      type: "primary",
      icon: "el-icon-download",
      onClick: _cache[1] || (_cache[1] = $event => $setup.fileDownload($setup.detail.id, $setup.detail.assetsName))
    }, {
      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("下载", -1)]))]),
      _: 1
    }, 8, ["loading"])), [[_directive_has, 'asset:lib:detail:down']])]), _cache[28] || (_cache[28] = _createElementVNode("div", {
      class: "title"
    }, "素材预览", -1)), _createElementVNode("div", _hoisted_17, _toDisplayString($setup.detail.assetsName), 1), $setup.detail.srcTyp === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_image, {
      lazy: "",
      style: {
        "width": "276px",
        "height": "276px"
      },
      fit: "contain",
      src: $setup.detail.srcOutUrl ? $setup.detail.srcOutUrl + '_s' : $setup.detail.srcInnUrl + '_s',
      "preview-src-list": [$setup.detail.srcOutUrl ? $setup.detail.srcOutUrl + '_s' : $setup.detail.srcInnUrl + '_s']
    }, null, 8, ["src", "preview-src-list"]), _cache[25] || (_cache[25] = _createElementVNode("div", {
      style: {
        "text-align": "center"
      }
    }, "（点击查看大图）", -1))])) : _createCommentVNode("", true), $setup.detail.srcTyp === '3' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("video", {
      width: "276",
      height: "276",
      src: $setup.detail.srcOutUrl ? $setup.detail.srcOutUrl : $setup.detail.srcInnUrl,
      muted: "",
      controls: "controls"
    }, " 您的浏览器不支持 HTML5 video 标签。 ", 8, _hoisted_20)])) : _createCommentVNode("", true), $setup.detail.srcTyp === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("audio", {
      style: {
        "width": "276px"
      },
      src: $setup.detail.srcOutUrl ? $setup.detail.srcOutUrl : $setup.detail.srcInnUrl,
      controls: "controls"
    }, null, 8, _hoisted_22)])) : _createCommentVNode("", true), $setup.detail.srcTyp && $setup.detail.srcTyp !== '1' && $setup.detail.srcTyp !== '2' && $setup.detail.srcTyp !== '3' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("img", {
      style: {
        "width": "120px",
        "height": "100px"
      },
      src: _ctx.srcType[$setup.detail.srcTyp] && _ctx.srcType[$setup.detail.srcTyp].src ? _ctx.srcType[$setup.detail.srcTyp].src : _ctx.srcType[6].src
    }, null, 8, _hoisted_24)])) : _createCommentVNode("", true), _cache[29] || (_cache[29] = _createElementVNode("div", {
      class: "title"
    }, "素材属性", -1)), $setup.detail.srcTyp ? (_openBlock(), _createElementBlock("div", _hoisted_25, "素材类型：" + _toDisplayString(_ctx.srcType[$setup.detail.srcTyp] && _ctx.srcType[$setup.detail.srcTyp].typ ? _ctx.srcType[$setup.detail.srcTyp].typ : _ctx.srcType[6].typ), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, "素材大小：" + _toDisplayString(($setup.detail.srcFileLength / 1024 / 1024).toFixed(2)) + "M", 1), $setup.detail.srcTyp === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_27, "素材尺寸：" + _toDisplayString($setup.detail.srcSize) + "（px）", 1)) : _createCommentVNode("", true), _cache[30] || (_cache[30] = _createElementVNode("div", {
      class: "title"
    }, "素材状态", -1)), $setup.detail.status === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
      key: 6,
      type: "success",
      size: "mini",
      style: {
        "margin": "8px"
      }
    }, {
      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("在线", -1)]))]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_el_tag, {
      key: 7,
      type: "danger",
      size: "mini",
      style: {
        "margin": "8px"
      }
    }, {
      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("已下线", -1)]))]),
      _: 1
    }))]),
    _: 1
  })]), _createVNode(_component_tag_modal, {
    modelValue: $setup.tagModalShow,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.tagModalShow = $event),
    onChooseHandler: $setup.addTagHandler
  }, null, 8, ["modelValue", "onChooseHandler"]), _createVNode(_component_add_assets_product, {
    ref: "addAsProdc",
    assetId: $props.id,
    onOk: $setup.addAsProdcOk
  }, null, 8, ["assetId", "onOk"]), _createVNode(_component_select_favorite, {
    ref: "selectFavoriteRef",
    choseAsset: _ctx.choseAsset,
    onOk: $setup.favorited
  }, null, 8, ["choseAsset", "onOk"]), _createVNode(_component_el_dialog, {
    title: "编辑",
    modelValue: _ctx.editShow,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.editShow = $event),
    width: "500px"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_28, [_createVNode(_component_el_button, {
      onClick: _cache[6] || (_cache[6] = $event => _ctx.editShow = false)
    }, {
      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.confirmEdit
    }, {
      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      "label-width": "100px",
      size: "small"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "生效时间"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.date = $event),
          type: "daterange",
          "range-separator": "至",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "素材状态"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: _ctx.status,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.status = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("上线", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("下线", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "备注"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.remark,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.remark = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_add_assets_product, {
    ref: "addAsProdc",
    assetId: $props.id,
    onOk: $setup.addAsProdcOk
  }, null, 8, ["assetId", "onOk"])], 64);
}